<template>
  <div class="page-wrapper">
    <Overview @tab="switchTab" v-if="tab_switch == 'overview'"></Overview>
    <Subcription @tab="switchTab" v-if="tab_switch == 'subcription' && $checkPermission('video_storage')"></Subcription>
    <Streamed @tab="switchTab" v-if="tab_switch == 'streamed' && $checkPermission('event_streaming')"></Streamed>
    <Voting @tab="switchTab" v-if="tab_switch == 'voting' && $checkPermission('voting')"></Voting>
    <Events @tab="switchTab" v-if="tab_switch == 'e-ticket' && $checkPermission('events')"></Events>
    <Donation @tab="switchTab" v-if="tab_switch == 'donation' && $checkPermission('donation')"></Donation>
  </div>
</template>
<script>
import Overview from "./Overview.vue";
import Subcription from "./Subcription.vue";
import Streamed from "./Streamed.vue";
import Voting from "./Voting.vue";
import Events from "./Events.vue";
import Donation from "./Donation.vue"
export default {
  components: {
    Overview,
    Subcription,
    Streamed,
    Voting,
    Events,
    Donation
  },
  data: () => ({
    tab_switch: "overview",
  }),
  watch: {
    "$route.params.tab"(tab) {
      if (tab) {
        this.tab_switch = tab;
      } else {
        this.tab_switch = "overview";
      }
    },
  },
  mounted() {
    let vm = this;
    if (vm.$route.params.tab) {
      vm.tab_switch = vm.$route.params.tab;
    }
  },
  methods: {
    switchTab(tab) {
      let vm = this;
      vm.tab_switch = tab;
      vm.$router.push({ name: "s_dashboard", params: { tab: tab } });
    },
  },
};
</script>
<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  min-height: 0;
}
</style>
